import React, { Component, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message, Form, Input, Button, Upload } from 'antd';
import { FormOutlined, PlusOutlined } from '@ant-design/icons';
import './applyUser.scss';
import HTTP from '../../script/service';
import Util from '../../script/util';
import CusUpload from '../../components/cusUpload/CusUpload';

class ApplyClassly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      formValues: {},
      fileList: [],
    };
  }
  componentDidMount() {
    if (this.props.mode == 'content') {
      this.getUserBaseInfo();
    }
  }
  showModal = () => {
    this.getUserBaseInfo();
  };
  hideModal = () => {
    this.setState({ visible: false }, () => {
      this.props.nextEvent && this.props.nextEvent();
    });
  };
  getUserBaseInfo = () => {
    HTTP._find_GodSimpleByUid({ uid: this.props.base.uid }).then((res) => {
      if (res.code == 200) {
        const fileList = [];
        res.data.wallPicList.forEach((item, index) => {
          fileList.push({
            uid: index,
            status: 'done',
            pic: item,
            url: Util.transImgUrl(item, '200x200'),
          });
        });
        this.setState({ formValues: res.data, fileList });
      } else {
        message.warning(res.message);
      }
    });
  };
  handleCurrencyChange = (v, name) => {
    const { formValues } = this.state;
    formValues[name] = v;
    this.setState({ formValues });
  };
  handleChangeByAvatar = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    } else if (info.file.status === 'done') {
      const res = info.file.response;
      if (res.code === 200) {
        this.handleCurrencyChange(res.data.center, 'avatar');
      } else {
        message.error((res && res.message) || '上传失败，请稍候重试');
      }
      this.setState({ loading: false });
    } else if (info.file.status === 'error') {
      message.error('上传失败，请稍后重试~');
      this.setState({ loading: false });
    }
  };
  handleChangeByWaill = ({ fileList }) => {
    this.setState({ fileList });
  };
  handleSubmit = () => {
    const { formValues, fileList } = this.state;
    if (!formValues.nickname) {
      message.warning('请填写昵称');
      return;
    }
    if (!formValues.avatar) {
      message.warning('请上传头像');
      return;
    }
    if (fileList.length < 1) {
      message.warning('请上传照片墙,最多可上传5张');
      return;
    }
    const wallPicList = [];
    fileList.forEach((item, index) => {
      if (item.response && item.response.code == 200) {
        wallPicList[index] = item.response.data.center;
      } else if (item.pic) {
        wallPicList[index] = item.pic;
      }
    });
    this.setState({ loading: true });
    HTTP._update_GodSimple({
      uid: formValues.uid,
      nickname: formValues.nickname,
      avatar: formValues.avatar,
      wallPicList: wallPicList.toString(),
    }).then((res) => {
      this.setState({ loading: false });
      if (res.code == 200) {
        this.hideModal();
      } else {
        message.warning(res.message);
      }
    });
  };
  render() {
    const { mode, base } = this.props;
    const { visible, formValues, fileList } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 },
      },
    };
    const avatarUploadProps = {
      name: 'file',
      accept: '.png,.jpg',
      listType: 'picture-card',
      className: 'avatar-uploader',
      action: base.rootConfig?.ctxPath + '/file/api/base/upload',
      showUploadList: false,
      headers: {
        authorization: base.token,
        uid: base.uid,
      },
    };
    const contentHtml = (
      <Scrollbar className="apply-scroll-bar" style={{ height: '600px' }}>
        <div
          className="iscroll-html"
          id="apply-scroll-bar"
          style={{ padding: '20px 50px' }}
        >
          <div className="myinfo-box">
            <div className="box-bg">
              <h1>完善基本信息</h1>
              <Form
                {...formItemLayout}
                className="apply-form"
                onFinish={this.handleSubmit}
              >
                <Form.Item label="昵称">
                  <div className="control-row">
                    <Input
                      style={{ width: '300px' }}
                      maxLength={12}
                      type="text"
                      placeholder="请填写昵称"
                      value={formValues.nickname}
                      onChange={(v) => {
                        this.handleCurrencyChange(v.target.value, 'nickname');
                      }}
                    />
                    <span className="control-count">
                      {formValues.nickname ? formValues.nickname.length : 0}/12
                    </span>
                  </div>
                </Form.Item>
                <Form.Item label="头像">
                  <div className="cz-map">
                    <Upload
                      {...avatarUploadProps}
                      onChange={this.handleChangeByAvatar}
                    >
                      {formValues.avatar ? (
                        <div className="cover-avatar">
                          <img
                            className="upload-image"
                            src={Util.transImgUrl(formValues.avatar)}
                            alt="avatar"
                            style={{ width: '100%' }}
                          />
                          <div className="edit-pic">
                            <span>
                              <FormOutlined />
                              更换
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="uploadButton">
                          <PlusOutlined />
                        </div>
                      )}
                    </Upload>
                  </div>
                </Form.Item>
                <Form.Item label="照片墙">
                  <p className="form-desc">
                    请尽量上传正方形图片，2M以内的JPG/PNG格式，最多5张哦~
                  </p>
                  <div className="cz-map pic-upload">
                    <CusUpload
                      size={4}
                      listType="picture-card"
                      showUploadList
                      fileList={fileList}
                      changeUpload={this.handleChangeByWaill}
                    >
                      {fileList.length >= 4 ? null :  <PlusOutlined />}
                    </CusUpload>
                   
                  </div>
                </Form.Item>
                <Form.Item>
                  <div className="form-submits">
                    {mode == 'content' ? (
                      <Button
                        htmlType="submit"
                        loading={this.state.loading}
                        className="daidai-btn-primary"
                      >
                        下一步
                      </Button>
                    ) : (
                      <Button
                        htmlType="submit"
                        loading={this.state.loading}
                        className="daidai-btn-primary"
                      >
                        提交审核
                      </Button>
                    )}
                  </div>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </Scrollbar>
    );
    return (
      <Fragment>
        {mode == 'content' ? (
          <Fragment>{contentHtml}</Fragment>
        ) : (
          <Modal
            open={visible}
            width="980px"
            wrapClassName="daidai-modal-style has-top-border"
            centered={true}
            title={'个人资料'}
            footer={null}
            keyboard={false}
            maskClosable={false}
            destroyOnHidden={true}
            onCancel={this.hideModal}
          >
            <div>{contentHtml}</div>
          </Modal>
        )}
      </Fragment>
    );
  }
}
ApplyClassly.defaultProps = {
  mode: 'content', // content || modal
};

export default withRouter(ApplyClassly, { withRef: true });
